<template lang="pug">
el-header
  el-container
    el-aside
      router-link.header-link(to="/dashboard")
        img.logo(src="@/assets/logo.svg")
    el-main
      el-button.logout(
        @click="logout()"
        type="danger"
        v-if="isAuthenticated"
        plain) Log Out
</template>

<script>
import AuthService from '@/services/AuthService';

export default {
  data() {
    return {
      isAuthenticated: AuthService.isAuthenticated,
    };
  },
  methods: {
    logout() {
      AuthService.logout();
    },
  },
};
</script>

<style lang="stylus" scoped>
.logo
  height 30px
  width 75px
  margin-top 15px

.el-header
  line-height 60px
  // background-color #ecf5ff
  box-shadow 0 0 1px rgba(0, 0, 0, .3)
  z-index 2001

  .el-main
    padding 0
    text-align right
</style>



// WEBPACK FOOTER //
// src/components/AdminHeader.vue